let emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let mobilePhoneRegex = /(07[2-9][0-9]{7})/;
let ibanRegex = /RO[a-zA-Z0-9]{2}\s?([a-zA-Z]{4}\s?){1}([a-zA-Z0-9]{4}\s?){4}\s?/;
let gpsCoordonateRegex = /^([\d]{1,2})((\.)([\d]{6}))$/;
let alphaNumericRegex = /^[\x00-\x7F]+$/;
let numericRegex = /^[0-9]+$/;

export default {
	validatePassword(password, confirmPassword) {
		var passwordLengthValid = false;
		var containsLetter = false;
		var containsNumber = false;
		var passwordLength = password.length;
		var validPassword = false;
		var confirmPasswordValid = false;
		if (passwordLength > 7) {
			passwordLengthValid = true;
		}
		containsLetter = /[a-z]|[A-Z]/.test(password);
		containsNumber = /\d/.test(password);
		if (containsLetter && containsNumber) {
			validPassword = false;
			if (passwordLengthValid) {
				if (password == confirmPassword) {
					confirmPasswordValid = true;
					validPassword = true;
				}
			}
		}

		return {
			passwordValid: validPassword,
			passwordLengthValid: passwordLengthValid,
			containsLetter: containsLetter,
			containsNumber: containsNumber,
			confirmPasswordValid: confirmPasswordValid,
		};
	},
	validateEmail(email) {
		return emailRegex.test(email);
	},
	validateMobilePhone(mobilePhone) {
		return mobilePhoneRegex.test(mobilePhone);
	},
	validateIBAN(iban) {
		return ibanRegex.test(iban)
	},
	validateGPSCoordonate(coord) {
		return gpsCoordonateRegex.test(coord)
	},
	validateOnlyAlphanumeric(coord) {
		return alphaNumericRegex.test(coord)
	},
	validateOnlyNumeric(coord) {
		return numericRegex.test(coord)
	}
};
